'use client';

import React from 'react';
import Link from 'next/link';
import { ChevronLeft } from 'lucide-react';

export interface BreadcrumbItem {
    text: string;
    url: string;
}

interface SymbolBreadcrumbProps {
    breadcrumbs?: BreadcrumbItem[];
    displayName?: string;
    symbolType?: 'crypto' | 'currency' | 'gold' | 'forex';
}

export const SymbolBreadcrumb: React.FC<SymbolBreadcrumbProps> = ({
    displayName = '',
    symbolType = 'crypto',
}) => {
    const getCategoryDetails = () => {
        switch (symbolType) {
            case 'currency':
                return { text: 'قیمت دلار و سایر ارزها', url: '/markets/currencies/' };
            case 'gold':
                return { text: 'قیمت طلا و سکه', url: '/markets/gold/' };
            case 'forex':
                return { text: 'فارکس', url: '/markets/forex/' };
            case 'crypto':
            default:
                return { text: 'ارزهای دیجیتال', url: '/markets/cryptocurrencies/' };
        }
    };

    const cat = getCategoryDetails();
    const items: BreadcrumbItem[] = [
        { text: 'قیمت لحظه ای', url: '/markets/' },
        { text: cat.text, url: cat.url },
        { text: displayName, url: '#' },
    ];

    return (
        <nav aria-label='Breadcrumb' className='py-2 mb-2 max-lg:ps-4'>
            <ol className='flex items-center flex-wrap gap-1.5 text-xs text-gray-500 dark:text-gray-400'>
                {items.map((item, index) => {
                    const isLast = index === items.length - 1;
                    return (
                        <li key={index} className='flex items-center gap-1.5'>
                            {index > 0 && (
                                <ChevronLeft className='size-3.5 text-gray-400 dark:text-gray-600 flex-shrink-0' />
                            )}
                            {isLast || !item.url || item.url === '#' ? (
                                <></>
                            ) : (
                                <Link
                                    href={item.url}
                                    className='hover:text-blue-600 dark:hover:text-blue-400 transition-colors'
                                >
                                    {item.text}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};
